import { Basket } from '@wix/bookings-services-preferences-modal';
import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { CalendarContext } from '../../../../utils/context/contextFactory';
import { CalendarState } from '../../controller';
import { CloseDialogAction } from '../closeDialog/closeDialog';
import {
  mapBasketToCalendarSelections,
  storeCalendarSelections,
} from '@wix/bookings-catalog-calendar-viewer-utils';

export type OnServicesPreferencesConfirm = (basket: Basket) => void;

export const createOnServicesPreferencesConfirm =
  (
    { context }: ActionFactoryParams<CalendarState, CalendarContext>,
    closeDialog: CloseDialogAction,
  ): OnServicesPreferencesConfirm =>
  (basket) => {
    const {
      reloadWidget,
      flowAPI: {
        controllerConfig: {
          platformAPIs: {
            storage: { session },
          },
        },
      },
    } = context;

    const calendarSelections = mapBasketToCalendarSelections(basket);
    storeCalendarSelections({ calendarSelections, session });

    closeDialog();
    reloadWidget();
  };
